import { noddiAsync, URLKeys } from 'noddi-async';

import { TireOfferNextInstructions } from './TireOfferNextInstructions';

export const TireOfferConfirmationText = ({ slug }: { slug: string }) => {
  const { data: tireOffer, isPending: isTireOfferPending } = noddiAsync.useGet({
    type: URLKeys.getCarTireQuoteBySlug,
    input: { carTireQuoteSlug: slug }
  });

  return (
    <div className='w-full'>
      <TireOfferNextInstructions
        isPending={isTireOfferPending}
        hasActiveTireHotelContractForWheelSet={tireOffer?.hasActiveTireHotelContractForWheelSet}
      />
    </div>
  );
};
